/** Canonical QoreConnect paths */
export const QC_PATHS = {
  hub: '/qoreconnect',
  forum: '/qoreconnect/forum',
  mentorship: '/qoreconnect/mentorship',
  jobs: '/qoreconnect/jobs',
};

export const HUB_TILES = [
  { id: 'forum', path: QC_PATHS.forum, icon: 'forum', color: '#06b6d4', labelKey: 'qoreConnect.tiles.forum.title', descKey: 'qoreConnect.tiles.forum.desc' },
  { id: 'mentorship', path: QC_PATHS.mentorship, icon: 'mentorship', color: '#8b5cf6', labelKey: 'qoreConnect.tiles.mentorship.title', descKey: 'qoreConnect.tiles.mentorship.desc' },
  { id: 'jobs', path: QC_PATHS.jobs, icon: 'jobs', color: '#10b981', labelKey: 'qoreConnect.tiles.jobs.title', descKey: 'qoreConnect.tiles.jobs.desc' },
];

export const VALUE_PILLARS = [
  { id: 'learn', icon: 'learn', labelKey: 'qoreConnect.pillars.learn.title', descKey: 'qoreConnect.pillars.learn.desc' },
  { id: 'match', icon: 'match', labelKey: 'qoreConnect.pillars.match.title', descKey: 'qoreConnect.pillars.match.desc' },
  { id: 'grow', icon: 'grow', labelKey: 'qoreConnect.pillars.grow.title', descKey: 'qoreConnect.pillars.grow.desc' },
];

export const QC_NAV = [
  { id: 'hub', path: QC_PATHS.hub, labelKey: 'qoreConnect.nav.hub' },
  { id: 'forum', path: QC_PATHS.forum, labelKey: 'qoreConnect.nav.forum' },
  { id: 'mentorship', path: QC_PATHS.mentorship, labelKey: 'qoreConnect.nav.mentorship' },
  { id: 'jobs', path: QC_PATHS.jobs, labelKey: 'qoreConnect.nav.jobs' },
];

export const PAGE_META = {
  forum: {
    accent: 'cyan',
    badgeKey: 'qoreConnect.pages.forum.badge',
    titleKey: 'qoreConnect.pages.forum.title',
    accentKey: 'qoreConnect.pages.forum.titleAccent',
    subtitleKey: 'qoreConnect.pages.forum.subtitle',
  },
  mentorship: {
    accent: 'violet',
    badgeKey: 'qoreConnect.pages.mentorship.badge',
    titleKey: 'qoreConnect.pages.mentorship.title',
    accentKey: 'qoreConnect.pages.mentorship.titleAccent',
    subtitleKey: 'qoreConnect.pages.mentorship.subtitle',
  },
  jobs: {
    accent: 'emerald',
    badgeKey: 'qoreConnect.pages.jobs.badge',
    titleKey: 'qoreConnect.pages.jobs.title',
    accentKey: 'qoreConnect.pages.jobs.titleAccent',
    subtitleKey: 'qoreConnect.pages.jobs.subtitle',
  },
};